import { render, staticRenderFns } from "./FilesUpload.vue?vue&type=template&id=4bc57225&scoped=true"
import script from "./FilesUpload.vue?vue&type=script&lang=js"
export * from "./FilesUpload.vue?vue&type=script&lang=js"
import style0 from "./FilesUpload.vue?vue&type=style&index=0&id=4bc57225&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc57225",
  null
  
)

export default component.exports